import React from "react";

const STATUS_STYLES = {
  pending: "text-yellow-900 bg-yellow-100 border-yellow-300",
  ongoing: "text-blue-900 bg-blue-100 border-blue-300",
  on_review: "text-indigo-900 bg-indigo-100 border-indigo-300",
  complete: "text-green-900 bg-green-100 border-green-300",
  failed: "text-red-900 bg-red-100 border-red-300",
};

const STATUS_LABELS = {
  pending: "Pending",
  ongoing: "Ongoing",
  on_review: "On Review",
  complete: "Complete",
  failed: "Failed",
};

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "text-zinc-900 bg-zinc-100 border-zinc-300";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider border ${cls}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}

const CATEGORY_STYLES = {
  Maintenance: "text-amber-800 bg-amber-50 border-amber-200",
  Security: "text-red-800 bg-red-50 border-red-200",
  Billing: "text-emerald-800 bg-emerald-50 border-emerald-200",
  Cleanliness: "text-sky-800 bg-sky-50 border-sky-200",
  "General Reporting": "text-slate-800 bg-slate-50 border-slate-200",
};

export function CategoryBadge({ category }) {
  const cls = CATEGORY_STYLES[category] || "text-zinc-800 bg-zinc-50 border-zinc-200";
  return (
    <span
      data-testid={`category-badge-${category}`}
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider border ${cls}`}
    >
      {category}
    </span>
  );
}

export const STATUSES = ["pending", "ongoing", "on_review", "complete", "failed"];
export const CATEGORIES = ["Maintenance", "Security", "Billing", "Cleanliness", "General Reporting"];
